import {Component, OnDestroy} from '@angular/core';
import {AppComponent} from './app.component';
import {AppMainComponent} from './app.main.component';
import {BreadcrumbService} from './app.breadcrumb.service';
import {Subscription} from 'rxjs';
import {MenuItem} from 'primeng/api';
import {CredentialsService} from '@app/auth/credentials.service';
import {AppService} from '@shared/services/app.service';
import {UntilDestroy} from '@ngneat/until-destroy';
import {ReserveRepository} from '@app/@core/repositories/reserve.repository';
import {UserRepository} from '@app/@core/repositories/user.repository';
import {formly} from '@shared/helper/formly-helpers';
import {BookingSearch} from '@shared/helper/search/booking-search';
import {UserSearch} from '@shared/helper/search/user-search';

function getImageFromFirstChar(userName: string): string {
    const avatars: string[] = [
        'bear.png',
        'chicken.png',
        'panda.png',
        'rabbit.png',
        'sea-lion.png'
    ];

    const avatarIndex = userName.charAt(0).charCodeAt(0) % avatars.length;
    return avatars[avatarIndex];
}


@UntilDestroy()
@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styles: [`
        .search-icon {
            font-size: 16px;
            top: -2px;
            margin-right: 10px;
        }
    `]
})
export class AppTopBarComponent implements OnDestroy {
    items: MenuItem[] = [
        {
            label: 'Change Password',
            icon: 'pi pi-key',
            command: () => this.changePassword()
        },
        {
            label: 'Logout',
            icon: 'pi pi-sign-out',
            command: () => this.logout()
        }
    ];

    bookingSearch: BookingSearch;
    userSearch: UserSearch;

    avatarImage: string;

    private readonly subscription: Subscription;

    constructor(public breadcrumbService: BreadcrumbService,
                public app: AppComponent,
                public appService: AppService,
                public appMain: AppMainComponent,
                private reserveRepository: ReserveRepository,
                private userRepository: UserRepository,
                public credentialsService: CredentialsService
    ) {
        this.bookingSearch = new BookingSearch(appService, reserveRepository, (value) => {
            this.appService.navigateToReserve(value);
        });

        this.userSearch = new UserSearch(appService, userRepository, (id => {
            // this.appService.navigateToUser(value);
            this.appService.redirect(`/user/${id}`);
        }));

        this.subscription = this.credentialsService.name$.subscribe(name => {
            this.avatarImage = getImageFromFirstChar( name ?? 'A');
        });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    logout() {
        this.appService.confirm('Logout', () => {
            this.credentialsService.logout();
        });
    }

    private changePassword() {
        this.appService.showInputDialog('Enter new password', [
            formly.password('currentPassword', 'Current', {placeholder: 'Enter Your Current Password'}),
            formly.password('password', 'New', {minLength: 6, placeholder: 'Enter Your Secure Password'})
        ]).onClose.subscribe(({password, currentPassword}) => {
            this.credentialsService.setPassword(currentPassword, password).subscribe(() => {
                this.appService.toastSuccess('Set new password');
            });
        });
    }

    newBooking() {
        this.appService.navigateByUrl(`/user/create-booking`);
    }
}

